import { useCallback, useEffect, useRef } from 'react';
import useDevices from '../useDevices/useDevices';
import useMediaStreamTrack from '../useMediaStreamTrack/useMediaStreamTrack';
import useVideoContext from '../useVideoContext/useVideoContext';

export default function useFlipCameraToggle() {
  const { localTracks } = useVideoContext();
  const videoTrack = localTracks.find(
    (t: any) => t.trackMediaType === 'video' && !(t as any).trackName?.includes?.('screen')
  );
  const mediaStreamTrack = useMediaStreamTrack(videoTrack);
  const { videoInputDevices } = useDevices();
  const videoOnly = videoInputDevices.filter((d): d is MediaDeviceInfo => d.kind === 'videoinput');
  const flipIndexRef = useRef(0);

  useEffect(() => {
    const id = mediaStreamTrack?.getSettings?.()?.deviceId;
    if (!id || videoOnly.length < 2) return;
    const idx = videoOnly.findIndex(d => d.deviceId === id);
    if (idx >= 0) flipIndexRef.current = idx;
  }, [mediaStreamTrack, videoOnly]);

  const toggleFacingMode = useCallback(() => {
    if (!videoTrack || videoOnly.length < 2) return;
    const setDevice = (videoTrack as any).setDevice;
    if (typeof setDevice !== 'function') return;

    const nextIdx = (flipIndexRef.current + 1) % videoOnly.length;
    flipIndexRef.current = nextIdx;
    const nextId = videoOnly[nextIdx]?.deviceId;
    if (!nextId) return;

    setDevice.call(videoTrack, nextId).catch(() => {
      /* revert index on failure */
      flipIndexRef.current = (nextIdx - 1 + videoOnly.length) % videoOnly.length;
    });
  }, [videoTrack, videoOnly]);

  return {
    flipCameraDisabled: !videoTrack,
    toggleFacingMode,
    flipCameraSupported: videoOnly.length > 1,
  };
}
